module.exports = "https://coursera_assets.s3.amazonaws.com/images/7ca2e1552fbd35b796a2f6cceda7c9d1.svg";